import styled from 'styled-components'
import theme from '@app/ui/theme'

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`

export const Subtitle = styled.p`
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #666;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`

export const PresetGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`

export const PresetCard = styled.button<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 2px solid
    ${(props) => (props.isSelected ? theme.colors.secondary2 : '#e4e4e4')};
  background-color: ${(props) =>
    props.isSelected ? '#f0f7ff' : 'transparent'};
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &:hover {
    border-color: ${(props) =>
      props.isSelected ? theme.colors.secondary2 : theme.colors.light};
  }
`

export const PresetText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const PresetLabel = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${theme.colors.black};
`

export const PresetHint = styled.span`
  font-size: 13px;
  color: #666;
`

export const PresetCheck = styled.span<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid
    ${(props) => (props.isSelected ? theme.colors.secondary2 : '#d8d8d8')};
  background-color: ${(props) =>
    props.isSelected ? theme.colors.secondary2 : 'transparent'};
`

export const CustomHint = styled.span`
  font-size: 13px;
  color: #666;
`

export const HoleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 8px;
`

export const HoleChip = styled.button<{ inRange: boolean; isEdge: boolean }>`
  height: 40px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: ${(props) => (props.isEdge ? 700 : 500)};
  color: ${(props) => (props.isEdge ? theme.colors.white : theme.colors.black)};
  background-color: ${(props) =>
    props.isEdge
      ? theme.colors.secondary2
      : props.inRange
      ? theme.colors.automatic
      : theme.colors.light2};
  border: 1px solid
    ${(props) =>
      props.isEdge
        ? theme.colors.secondary2
        : props.inRange
        ? theme.colors.automatic
        : 'transparent'};
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: ${theme.colors.secondary2};
  }
`

export const Summary = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  background-color: ${theme.colors.light2};
`

export const SummaryRange = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.colors.black};
`

export const SummaryCount = styled.span`
  font-size: 13px;
  color: #666;
`
